var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7294 3.23918C12.3504 2.56637 12.6609 2.22997 12.9908 2.03374C13.7869 1.56027 14.7672 1.54554 15.5766 1.9949C15.912 2.18114 16.2321 2.50807 16.8722 3.16194C17.5122 3.8158 17.8323 4.14274 18.0146 4.48541C18.4545 5.31223 18.4401 6.31363 17.9766 7.12689C17.7845 7.46393 17.4552 7.78112 16.7966 8.41548L8.96016 15.9632C7.71203 17.1654 7.08797 17.7664 6.30802 18.0711C5.52807 18.3757 4.67064 18.3533 2.95577 18.3085L2.72245 18.3024C2.20039 18.2887 1.93936 18.2819 1.78762 18.1097C1.63589 17.9375 1.6566 17.6716 1.69803 17.1398L1.72053 16.851C1.83714 15.3543 1.89545 14.6059 2.18772 13.9332C2.48 13.2604 2.98417 12.7142 3.99249 11.6217L11.7294 3.23918Z",
    stroke: "#2177FE",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 3.33398L16.6673 9.16732",
    stroke: "#2177FE",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 18.334L18.3346 18.334",
    stroke: "#2177FE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconMeet);
export default __webpack_public_path__ + "static/media/editIconMeet.f9b426328ce189472ec08ac5cb5a231d.svg";
export { ForwardRef as ReactComponent };